import { render, staticRenderFns } from "./ClientDocumentStorage.vue?vue&type=template&id=7b498d57&"
import script from "./ClientDocumentStorage.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports